import styled from '@emotion/styled';
import {Container, Grid, Button, Box, TextField, CircularProgress, Link, MenuItem, Select} from '@mui/material'
import MovingLogo from '../components/MovingLogo';
import { CustomConnectButton } from '../components/CustomConnectButton.js';
import { genesToString, stringToGenes, crossBreed } from '../javascripts/OnChainDrawer';
import { useSearchParams } from "react-router-dom";

import React, { useState, useEffect } from 'react';
import { useAccount, usePrepareContractWrite, useContractWrite, useWaitForTransaction, useContractReads, useContractRead, useNetwork, useContractEvent} from 'wagmi'
import { parseEther, formatEther } from '@ethersproject/units'
import Onchain from '../components/Onchain';
import { CONTRACT_ADDRESS, ONCHAINS_ABI, ONCHAIN_LIMIT, OPENSEA_URL, SCANNER_URL, OPENSEA_NFT_URL } from '../constants';
import { useDebounce } from 'usehooks-ts';


const Header = styled('div')`
  font-size: 40px;
  margin-top: 24px;
  margin-bottom: 24px;
  text-align: center;
`;

const Subtitle = styled('div')`
  margin: 0px;
  font-size: 16px;
`;

const HeaderBox = styled('div')`
  display: inline;
  vertical-align: middle;
  width: 100%;
  text-align: center;
`;


// background: #d7f31f;
// box-shadow: 0px 0px 5px 5px #d7f31f;
const Strip = styled(Container)`
  margin-top: 24px;
  margin-bottom: 24px;
  min-width: 360px;
  `;

const RandomButton = styled(Button)(({ theme }) => ({
  maxWidth: '376px',
  margin: '0px',
  marginBottom: '12px',
}));

const Fee = styled('div')`
  font-size: 12px;
  margin: 4px;
  font-weight: 800;
  display: inline-block;
  letter-spacing: -0.5px;
`;

const Success = styled('div')`
  font-size: 24px;
  margin: auto;
  text-align: center;
  padding: 24px;
`;


export default function Onchainlings() {

  const { address } = useAccount()
  const [params, setParams] = useSearchParams();

  const [totalSupply, setTotalSupply] = useState(0);
  const [ownerBalance, setOwnerBalance] = useState(0);
  const [incubation_fee, setIncubationFee] = useState(0);
  const [onchainlings, setOnchainlings] = useState([]);
  const [fatherGenome, setFatherGenome] = useState(null);
  const [motherGenome, setMotherGenome] = useState(null);
  const [motherOwner, setMotherOwner] = useState(null);
  const [childGenome, setChildGenome] = useState(null);
  const [mintedID, setMintedID] = useState(null);


  const [mother, setMother] = useState(params.get('mother') ? params.get('mother') : "");
  const [father, setFather] = useState(params.get('father') ? params.get('father') : "");

  useEffect(() => {
    if (mother != null && totalSupply > 0 && (mother < 0 || mother >= totalSupply)) {
      setMother(null);
      setMotherGenome(null);
      setChildGenome(null);
      setParams({father});
    }
    if (father != null && totalSupply > 0 && (father < 0 || father >= totalSupply)) {
      setFather(null);
      setFatherGenome(null);
      setChildGenome(null);
      setParams({mother});
    }
  }, [totalSupply, mother, father, setParams]);
  
  const potential = () => {
    if (!motherGenome || !fatherGenome) return;
    const mgenes = stringToGenes(motherGenome);
    const fgenes = stringToGenes(motherGenome);
    const genes = genesToString(crossBreed(mgenes, fgenes));
    setChildGenome(genes);
  }

  useEffect(() => {
    let timerFunc = setInterval(() => {
      potential();
    }, 400);
    potential();
    return () => clearInterval(timerFunc);
  }, [motherGenome, fatherGenome]);

  const { chain } = useNetwork();

  const contract = {
    address: CONTRACT_ADDRESS,
    abi: ONCHAINS_ABI,
  }

  const { data: reads, isError, isLoading: isReadsLoading } = useContractReads({
    contracts: [
      {
        ...contract,
        functionName: 'totalSupply',
      },
      {
        ...contract,
        functionName: 'balanceOf',
        args: [address],
        enabled: !!address,
      },
      {
        ...contract,
        functionName: 'incubation_fee',
      },
    ]
  }, [CONTRACT_ADDRESS])

  if (!isError && !isReadsLoading && !!reads) {
    const [_totalSupply, _ownerBalance, _incubation_fee] = reads;
    if (_totalSupply.status === 'success' && totalSupply !== Number(_totalSupply.result)) {
      setTotalSupply(Number(_totalSupply.result));
    }
    if (_ownerBalance.status === 'success' && ownerBalance !== _ownerBalance.result) {
      setOwnerBalance(_ownerBalance.result);
    }
    if (_incubation_fee.status === 'success' && incubation_fee !== _incubation_fee.result) {
      setIncubationFee(_incubation_fee.result);
    }
  }

  const { data: fatherOnchain } = useContractRead({
    ...contract,
    functionName: 'getOnchain',
    args: [father],
    enabled: father !== null && father >= 0 && father < totalSupply,
  }, [CONTRACT_ADDRESS, father]);

  if (fatherOnchain && fatherOnchain[0] !== fatherGenome) {
    setFatherGenome(fatherOnchain[0]);
  }

  const { data: motherOnchain } = useContractRead({
    ...contract,
    functionName: 'getOnchain',
    args: [mother],
    enabled: mother !== null && mother >= 0 && mother < totalSupply,
  }, [CONTRACT_ADDRESS, ]);

  if (motherOnchain && motherOnchain[0] !== motherGenome) {
    setMotherGenome(motherOnchain[0]);
  }

  const { data: motherOwnerRead } = useContractRead({
    ...contract,
    functionName: 'ownerOf',
    args: [mother],
    enabled: mother !== null && mother >= 0 && mother < totalSupply,
  }, [CONTRACT_ADDRESS, mother]);

  if (motherOwnerRead && motherOwnerRead !== motherOwner) {
    setMotherOwner(motherOwnerRead);
  }

 
  const contracts = ownerBalance === 0n ? [] : [...Array(Number(ownerBalance)).keys()].map((i) => {
    return {
      ...contract,
      functionName: 'tokenOfOwnerByIndex',
      args: [address, Number(i)],
      enabled: !!address && ownerBalance > 0,
    }
  });
  
  const { data: otData, isError: otIsError, isLoading: otIsReadsLoading } = 
    useContractReads({ contracts}, [CONTRACT_ADDRESS, ownerBalance, address])

  if (!otIsError && !otIsReadsLoading && !!otData && otData.length > 0 && otData[0].status === 'success') {
    const _ownerTokens = otData.map((d) => Number(d.result) );
    if (!!onchainlings && onchainlings.length === 0) {
      setOnchainlings(_ownerTokens);
    }
  }

  useContractEvent({
    address: CONTRACT_ADDRESS,
    abi: ONCHAINS_ABI,
    eventName: 'Transfer',
    listener(log) {
      if (log.length > 0 && log[0]?.args?.to === address) {
        setMintedID(log[0].args.tokenId);
      }
    },
 })
  
  const { isConnected } = useAccount();

  const debouncedParams = useDebounce([mother, father, motherOwner, address, isConnected], 500);

  const { config } = usePrepareContractWrite({
    address: CONTRACT_ADDRESS,
    abi: ONCHAINS_ABI,
    value: incubation_fee || parseEther("0.01"),
    functionName: 'mintChild',
    args: [mother, father],
    gas: 300_000n,
    enabled: isConnected && incubation_fee && motherOwner === address && mother && father,
  }, [CONTRACT_ADDRESS, isConnected, debouncedParams]);

  const { data, write } = useContractWrite(config)
  const { isLoading, isSuccess } = useWaitForTransaction({
    hash: data?.hash,
  });

  const handleSetMother = (e) => {
    setMother(e.target.value);
    setParams({mother: e.target.value, father}, {replace: true});
  }

  const handleSetFather = (e) => {
    setFather(e.target.value);
    setParams({mother, father: e.target.value}, {replace: true});
  }

  return (
    <Strip maxWidth="xs">
      <Grid container>
        <Grid container spacing={0} marginTop={1} textAlign="center">
          <Grid item xs={3}>
            <MovingLogo width={80} />
          </Grid>
          <Grid item xs={3}>
            <MovingLogo width={80} />
          </Grid>
          <Grid item xs={3}>
            <MovingLogo width={80} />
          </Grid>
          <Grid item xs={3}>
            <MovingLogo width={80} />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <HeaderBox>
            <Header>
              The Onchainlings
              <Subtitle>
                Children of <Link href="./">Pioneers of Basetown</Link>
              </Subtitle>
            </Header>
          </HeaderBox>
        </Grid>

      </Grid>
      
      <Grid container>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} lineHeight={2}>
            <p>
              Select two Onchain IDs to mint a new Onchainling.
              You may <Link href="{OPENSEA_URL}" target="_blank">browse the collection</Link> for inspiration.
            </p>
            <p>
              You must own the mother Onchain in order to mint an Onchainling. Most of the offspring's traits will be inherited from the mother.
            </p>
          </Grid>
          <Grid item xs={6}>
            <Box marginTop={2}>
              <Select
                fullWidth
                value={mother}
                onChange={(e) => handleSetMother(e)}
              >
                {onchainlings.map((id) => (
                  <MenuItem value={id} key={id}>{id}</MenuItem>
                ))}
                {!isConnected && (
                  <MenuItem value={0}>Please connect your wallet to see your Onchains here.</MenuItem>
                )}
                {onchainlings.length === 0 && (
                  <MenuItem value={0}>You need to own an Onchain to mint an Onchainling.</MenuItem>
                )}
              </Select>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <TextField value={father} placeholder='Father #' fullWidth variant="outlined" size="large" margin="normal" type="number" onChange={(e)=> handleSetFather(e)}/>
          </Grid>
          <Grid item xs={6}>
            {mother >= 0 && !!motherGenome && (
              <Onchain genome={motherGenome} width={180} />
            )}
          </Grid>
          <Grid item xs={6}>
            {father >= 0 && !!fatherGenome && (
              <Onchain genome={fatherGenome} width={180} />
            )}
          </Grid>
          {motherOwner !== address && !!mother && !!motherGenome && (
            <Grid item xs={12} color="red">
              You must own the mother Onchain in order to mint an Onchainling.
            </Grid>
          )}
          <Grid item xs={12}>
            {!isConnected && (
              <Box margin={2} textAlign="center">
                <Box marginBottom={2}>
                  Connect your wallet to mint Onchainlings.
                </Box>
                <CustomConnectButton></CustomConnectButton>
              </Box>
            )}
            { Number(totalSupply) < ONCHAIN_LIMIT && isConnected && !chain?.unsupported && (
              <RandomButton fullWidth variant="contained" size="large" onClick={() => write?.()} disabled={isSuccess || !write || isLoading}>
                MINT
                <Fee>{`${formatEther(incubation_fee)} ETH`}</Fee>
              </RandomButton>
            )}
          </Grid>
          <Grid item xs={12}>
            {isLoading && (
              <Box padding={2} textAlign="center">
                <CircularProgress color="inherit" size={32} margin={2} />
                <div>
                  Minting Onchainling...
                </div>              
              </Box>
            )}
            {isSuccess && (
              <Success>
                Successfully minted your Onchainling!

                <Box margin={3} marginLeft={'8px'}>
          
                  <a href={`https://twitter.com/intent/tweet?text=I+minted+my+first+Onchain+https://onchains.com`} target="_blank" rel="noreferrer">
                  <svg x="0px" y="0px" viewBox="0 0 1350 1150" width={52}>
                    <g>
                      <circle class="st0" cx="834.28" cy="610.6" r="481.33" stroke='#FFFFFF' strokeMiterlimit={10}/>
                      <g id="layer1" transform="translate(52.390088,-25.058597)">
                        <path id="path1009" fill='#FFFFFF' class="st1" d="M485.39,356.79l230.07,307.62L483.94,914.52h52.11l202.7-218.98l163.77,218.98h177.32 L836.82,589.6l215.5-232.81h-52.11L813.54,558.46L662.71,356.79H485.39z M562.02,395.17h81.46l359.72,480.97h-81.46L562.02,395.17 z"/>
                      </g>
                    </g>
                    </svg>
                  </a>&nbsp;

                  <a target='_blank' href={`${SCANNER_URL}${data?.hash}`} rel="noreferrer">
                    <svg viewBox="0 0 154 154" fill="none" width={40}>
                      <path d="M32.856 73.722C32.8562 72.8665 33.0253 72.0195 33.3538 71.2295C33.6822 70.4396 34.1634 69.7223 34.7698 69.1188C35.3762 68.5154 36.0958 68.0376 36.8873 67.713C37.6789 67.3884 38.5267 67.2234 39.3822 67.2274L50.2024 67.2626C51.9276 67.2626 53.5821 67.948 54.802 69.1678C56.0218 70.3877 56.7072 72.0422 56.7072 73.7674V114.68C57.9252 114.319 59.4897 113.933 61.2015 113.53C62.3906 113.251 63.4504 112.578 64.2089 111.621C64.9674 110.663 65.38 109.478 65.3798 108.256V57.5055C65.3798 55.7802 66.065 54.1256 67.2848 52.9055C68.5047 51.6855 70.1592 50.9999 71.8845 50.9995H82.7261C84.4514 50.9999 86.1059 51.6855 87.3258 52.9055C88.5456 54.1256 89.2309 55.7802 89.2309 57.5055V104.607C89.2309 104.607 91.9454 103.509 94.5894 102.393C95.5716 101.977 96.4097 101.282 96.9993 100.393C97.5889 99.5045 97.9038 98.462 97.9047 97.3955V41.2437C97.9047 39.5187 98.5898 37.8644 99.8094 36.6446C101.029 35.4247 102.683 34.7393 104.408 34.7389H115.25C116.975 34.7389 118.63 35.4243 119.849 36.6441C121.069 37.864 121.755 39.5185 121.755 41.2437V87.4835C131.154 80.6714 140.679 72.4788 148.238 62.6272C149.335 61.1972 150.061 59.5181 150.35 57.7396C150.64 55.9611 150.485 54.1384 149.9 52.4343C146.401 42.367 140.839 33.141 133.57 25.3467C126.301 17.5524 117.484 11.3614 107.685 7.16992C97.886 2.97846 87.3197 0.878835 76.6625 1.0054C66.0053 1.13196 55.4918 3.48194 45.795 7.90493C36.0981 12.3279 27.4313 18.7265 20.3493 26.6913C13.2673 34.656 7.92599 44.0115 4.66718 54.159C1.40838 64.3066 0.303866 75.0226 1.42431 85.6215C2.54475 96.2205 5.86549 106.469 11.174 115.711C12.0988 117.305 13.4592 118.602 15.0956 119.45C16.7321 120.298 18.5764 120.661 20.4121 120.497C22.4628 120.317 25.0161 120.061 28.0518 119.705C29.3733 119.555 30.5934 118.924 31.4796 117.932C32.3658 116.941 32.8562 115.658 32.8573 114.328V73.722" fill="#0A0B0D"/>
                      <path fill="#C0D0DB" d="M32.6191 139.343C44.047 147.657 57.5522 152.647 71.6404 153.761C85.7285 154.876 99.8504 152.071 112.443 145.658C125.036 139.244 135.61 129.471 142.993 117.421C150.376 105.371 154.282 91.5134 154.278 77.3813C154.278 75.6178 154.196 73.8732 154.079 72.1386C126.091 113.88 74.415 133.395 32.6217 139.336"/>
                    </svg>
                  </a>&nbsp;
                  <a target='_blank' href={!!mintedID ? `${OPENSEA_NFT_URL}${CONTRACT_ADDRESS}/${mintedID}` : OPENSEA_URL} rel="noreferrer">
                    <svg viewBox="0 0 90 90" fill="none" width={40}>
                      <path d="M90 45C90 69.8514 69.8514 90 45 90C20.1486 90 0 69.8514 0 45C0 20.1486 20.1486 0 45 0C69.8566 0 90 20.1486 90 45Z" fill="#2081E2"/>
                      <path d="M22.2011 46.512L22.3953 46.2069L34.1016 27.8939C34.2726 27.6257 34.6749 27.6535 34.8043 27.9447C36.76 32.3277 38.4475 37.7786 37.6569 41.1721C37.3194 42.5683 36.3948 44.4593 35.3545 46.2069C35.2204 46.4612 35.0725 46.7109 34.9153 46.9513C34.8413 47.0622 34.7165 47.127 34.5824 47.127H22.5432C22.2196 47.127 22.0301 46.7756 22.2011 46.512Z" fill="white"/>
                      <path d="M74.38 49.9149V52.8137C74.38 52.9801 74.2783 53.1281 74.1304 53.1928C73.2242 53.5812 70.1219 55.0052 68.832 56.799C65.5402 61.3807 63.0251 67.932 57.4031 67.932H33.949C25.6362 67.932 18.9 61.1727 18.9 52.8322V52.564C18.9 52.3421 19.0803 52.1618 19.3023 52.1618H32.377C32.6359 52.1618 32.8255 52.4022 32.8024 52.6565C32.7099 53.5072 32.8671 54.3764 33.2693 55.167C34.0461 56.7435 35.655 57.7283 37.3934 57.7283H43.866V52.675H37.4673C37.1391 52.675 36.9449 52.2959 37.1345 52.0277C37.2038 51.9214 37.2824 51.8104 37.3656 51.6856C37.9713 50.8257 38.8358 49.4895 39.6958 47.9684C40.2829 46.9421 40.8516 45.8463 41.3093 44.746C41.4018 44.5472 41.4758 44.3438 41.5497 44.1449C41.6746 43.7936 41.804 43.4653 41.8965 43.1371C41.9889 42.8597 42.0629 42.5684 42.1369 42.2956C42.3542 41.3617 42.4467 40.3723 42.4467 39.3459C42.4467 38.9437 42.4282 38.523 42.3912 38.1207C42.3727 37.6815 42.3172 37.2423 42.2617 36.8031C42.2247 36.4147 42.1554 36.031 42.0814 35.6288C41.9889 35.0416 41.8595 34.4591 41.7115 33.8719L41.6607 33.65C41.5497 33.2478 41.4573 32.864 41.3278 32.4618C40.9626 31.1996 40.5418 29.9698 40.098 28.8186C39.9362 28.3609 39.7512 27.9217 39.5663 27.4825C39.2935 26.8213 39.0161 26.2203 38.7619 25.6516C38.6324 25.3927 38.5214 25.1569 38.4105 24.9165C38.2857 24.6437 38.1562 24.371 38.0268 24.112C37.9343 23.9132 37.8279 23.7283 37.754 23.5434L36.9634 22.0824C36.8524 21.8836 37.0374 21.6478 37.2546 21.7079L42.2016 23.0487H42.2155C42.2247 23.0487 42.2294 23.0533 42.234 23.0533L42.8859 23.2336L43.6025 23.437L43.866 23.511V20.5706C43.866 19.1512 45.0034 18 46.4089 18C47.1116 18 47.7496 18.2866 48.2073 18.7536C48.665 19.2206 48.9517 19.8586 48.9517 20.5706V24.935L49.4787 25.0829C49.5204 25.0968 49.562 25.1153 49.599 25.143C49.7284 25.2401 49.9133 25.3835 50.1491 25.5591C50.3341 25.7071 50.5329 25.8874 50.7733 26.0723C51.2495 26.4561 51.8181 26.9508 52.4423 27.5194C52.6087 27.6628 52.7706 27.8107 52.9185 27.9587C53.723 28.7076 54.6245 29.5861 55.4845 30.557C55.7249 30.8297 55.9607 31.1071 56.2011 31.3984C56.4415 31.6943 56.6958 31.9856 56.9177 32.2769C57.209 32.6652 57.5233 33.0674 57.7961 33.4882C57.9256 33.687 58.0735 33.8904 58.1984 34.0892C58.5497 34.6209 58.8595 35.1711 59.1554 35.7212C59.2802 35.9755 59.4097 36.2529 59.5206 36.5257C59.8489 37.2608 60.1078 38.0098 60.2742 38.7588C60.3251 38.9206 60.3621 39.0963 60.3806 39.2535V39.2904C60.436 39.5124 60.4545 39.7482 60.473 39.9886C60.547 40.756 60.51 41.5235 60.3436 42.2956C60.2742 42.6239 60.1818 42.9336 60.0708 43.2619C59.9598 43.5763 59.8489 43.9045 59.7056 44.2143C59.4282 44.8569 59.0999 45.4996 58.7115 46.1006C58.5867 46.3225 58.4388 46.5583 58.2908 46.7802C58.129 47.016 57.9626 47.238 57.8146 47.4553C57.6112 47.7327 57.3939 48.0239 57.172 48.2828C56.9732 48.5556 56.7697 48.8284 56.5478 49.0688C56.2381 49.434 55.9422 49.7808 55.6324 50.1137C55.4475 50.331 55.2487 50.5529 55.0452 50.7517C54.8464 50.9736 54.643 51.1724 54.4581 51.3573C54.1483 51.6671 53.8894 51.9075 53.6721 52.1063L53.1635 52.5733C53.0896 52.638 52.9925 52.675 52.8908 52.675H48.9517V57.7283H53.9079C55.0175 57.7283 56.0716 57.3353 56.9223 56.6141C57.2136 56.3598 58.485 55.2594 59.9876 53.5997C60.0384 53.5442 60.1032 53.5026 60.1771 53.4841L73.8668 49.5265C74.1211 49.4525 74.38 49.6467 74.38 49.9149Z" fill="white"/>
                    </svg>
                  </a>
                </Box>
              </Success>
            )}
          </Grid>
          {!!childGenome && (
            <Grid item xs={12} marginBottom={10}>
              <Box margin={2} textAlign="center" fontWeight="bold">
                Potential Future Onchainlings
              </Box>
              <Onchain genome={childGenome} width={300} />
            </Grid>
          )}
        </Grid>
      </Grid>
      
    </Strip>
  );
}
